// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1VqXB","red":"Tag_red__2hwoq","green":"Tag_green__2ccJV","gray":"Tag_gray__2mo8h","yellow":"Tag_yellow__3iz4v"};